import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { SupermodalComponent } from "@app/components/common/supermodal.component";

@Component({
  selector: "supermodal-success",
  templateUrl: "./supermodal-success.component.html",
})
export class SupermodalSuccessComponent {
  @Input()
  title: string;
  @Input()
  subtitle: string;
  @Input()
  duration: number = 2000;
  @ViewChild("publishedSupermodal") supermodalComponent: SupermodalComponent;
  @ViewChild("loadingAnimation") loadingAnimationElementRef: ElementRef;
  @Output()
  complete = new EventEmitter();

  @Input()
  displayCloseButton: boolean = false;

  open() {
    this.supermodalComponent.open();
    setTimeout(() => {
      void this.loadingAnimationElementRef.nativeElement.parentNode.offsetWidth;
      this.loadingAnimationElementRef.nativeElement.classList.add("animate");
      setTimeout(() => {
        this.complete.emit();
      }, this.duration);
    }, 1000);
  }
}
